export default __webpack_public_path__ + "static/media/Tobu & Itro - Sunburst.c6611c50.mp3";